import dynamic from "next/dynamic";
import Loading from "@/components/common/Loading";
import Head from "next/head";
import SchemaTags from "@/components/common/SchemaTags";

const RetailIndustry = dynamic(() => import("../../components/industries/Retail/RetailIndustry"), {
   loading: () => <Loading />,
});

const MobileRetailIndustry = dynamic(
   () => import("../../components/industries/Retail/MobileRetailIndustry"),
   {
      loading: () => <Loading />,
   }
);

const Retail = ({ mobileView }) => {
   return (
      <>
         <Head>
            <title>Best Retail POS Billing Software India | Retail Billing Solutions</title>
            <meta name="description" content="Discover the best retail POS billing software with QueueBuster. Streamline your retail operations with advanced retail billing software, and retail POS solutions. Perfect for computer hardware billing systems and retail accounting." />
            <link rel="canonical" href="https://queuebuster.co/Industries/retail-pos-billing-software" />
            <link rel="alternate" href="https://queuebuster.co/Industries/retail-pos-billing-software" hrefLang="en-us" />
            <meta property="og:title" content="Best Retail POS Billing Software India | Retail Billing Solutions" />
            <meta property="og:description" content="Discover the best retail POS billing software with QueueBuster. Streamline your retail operations with advanced retail billing software, and retail POS solutions. Perfect for computer hardware billing systems and retail accounting." />
            <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/OG+Images/Retail_og.jpg" />
            <meta property="og:url" content="https://queuebuster.co/Industries/retail-pos-billing-software" />
            
         </Head>
         <SchemaTags page="retail-pos-billing-software" />
         {mobileView ? <MobileRetailIndustry /> : <RetailIndustry />}
      </>
   );
};

export default Retail;
